export default class Process {
  static env(){
    return {
      PLAYBACK_UPLOAD_BASE: process.env.PLAYBACK_UPLOAD_BASE,
      PLAYBACK_ENV_PRODUCTION: process.env.PLAYBACK_ENV_PRODUCTION,
      PROJECT_ENVIRONMENT: process.env.PROJECT_ENVIRONMENT,
      RAILS_ENV: process.env.RAILS_ENV
    };
  }
}
